import { render, staticRenderFns } from "./PeopleEvaluatedList.vue?vue&type=template&id=e5f61c24"
import script from "./PeopleEvaluatedList.vue?vue&type=script&lang=js"
export * from "./PeopleEvaluatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports